export const TECH_FORM_STORAGE_OPTIONS = { getOnInit: true };
export const TECH_FORM_CACHE_MODES = {
  editable: "editable",
  completed: "completed",
} as const;
export const TECH_FORM_VESSEL_CACHE_STORAGE_KEYS = {
  activeVessel: "techFormActiveVessel",
  drafts: "techFormDraftsByVessel",
};
